module.exports = __webpack_public_path__ + "img/edit.152de4ed.svg";